var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.59741V5.60704M8 10.8139V10.8402M11.78 13.3307H4.22005C3.1874 13.3307 2.31595 12.6483 2.04177 11.7145C1.92473 11.3159 2.06854 10.9008 2.28851 10.5473L6.06846 3.73141C6.95407 2.30828 9.04594 2.30828 9.93154 3.73141L13.7115 10.5473C13.9315 10.9008 14.0753 11.3159 13.9582 11.7145C13.6841 12.6483 12.8126 13.3307 11.78 13.3307Z",
    stroke: "#F31825",
    strokeWidth: 1.53,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableAlert);
export default __webpack_public_path__ + "static/media/TableAlert.52bc45163f977e9661982fbfb5e6d90d.svg";
export { ForwardRef as ReactComponent };